import { CSSProperties } from "react";
import { solutionColors } from "@smartsuite/types";

export const getSolutionColorStyles = (
  solutionColor: string,
): CSSProperties => {
  const colorPalette = solutionColors.find(
    ({ primary }) => solutionColor === primary,
  );
  return {
    "--solution-primary-color": colorPalette?.primary,
    "--solution-secondary-color": colorPalette?.secondary,
    "--solution-highlight-color": colorPalette?.highlight,
    "--solution-hover-color": colorPalette?.hover,
  } as CSSProperties;
};
